import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {Game} from "../Game";

export class IntroSlideShow extends SlideShowPage {

    constructor(texture: PIXI.Texture, showText: boolean) {
        super(undefined, undefined, undefined, undefined);

        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
            fontFamily: OpenSans.FAMILY,
            fontStyle: FontStyle.NORMAL,
            fontWeight: FontWeight.BOLD,
            dropShadow: true,
            dropShadowAngle: 8,
            dropShadowBlur: 4,
            dropShadowDistance: 4,
            fill: "#FFFC00",
            fontSize: 30,
            lineJoin: "round",
            stroke: "#434343",
            strokeThickness: 4
        });

        const featureImage: PIXI.Sprite = new PIXI.Sprite(texture);
        featureImage.anchor.set(0.5);
        this.addChild(featureImage);

        if (showText) {
            const textObj: PIXI.Text = new PIXI.Text(Game.apiPlugin.translations.translate("WIN UP TO") + " 25 000x " + Game.apiPlugin.translations.translate("BET"), textStyle);
            textObj.anchor.set(0.5);
            textObj.position.set(0, 185);
            if (Game.apiPlugin.gameClientConfiguration.isSet) {
                if (!Game.apiPlugin.gameClientConfiguration.showLowProbabilityGfx) {
                    textObj.visible = false;
                }
            } else {
                Game.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                    if (!Game.apiPlugin.gameClientConfiguration.showLowProbabilityGfx) {
                        textObj.visible = false;
                    }
                });
            }

            this.addChild(textObj);
        }
    }
}